<template>
  <div
    v-if="company"
    class="company-created"
    :class="{'company-created--error': error}"
  >
    <div class="d-flex">
      <div>
        <icon
          style="color: #14803a;width: 12px;margin-top: -2px;"
          :icon="error ? 'error' : 'success'"
        />
      </div>
      <div class="ml-2">
        <strong>
          {{ company.tag.name }}
        </strong>
        <div v-if="!error">
          This {{ type }} has completed processing.
        </div>
        <div v-else>
          There was an error trying to create a company with ticker <strong>{{ error }}</strong>
        </div>
        <div
          class="d-flex w-100 mt-3"
          style="border-color: #bfbfbf !important;"
        >
          <router-link
            v-if="!error"
            @click.native="reset"
            class="btn btn-link mr-4"
            :to="{ name: 'companies.view', params: { companyId: company.id } }"
          >
            Review
          </router-link>
          <button
            @click="reset"
            class="btn btn-link"
          >
            Dismiss
          </button>
        </div>
      </div>
      <div>
        <button
          @click="reset"
          class="btn btn-link"
          style="color: black !important;height: 25px;"
        >
          <icon
            icon="remove-tag"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCreated',
  props: {
    user: {
      required: true,
      type: Object,
    },

  },

  data () {
    return {
      error: null,
      company: null,
      type: 'Company',
    }
  },
  mounted () {
    this.$echo.private('admin')
        .listen('CompanyCreateSuccessEvent', (({user, company}) => {
          if (user.id === this.user.id) {
            this.company = company
            this.type = 'Company'
            this.error = null
            if (this.$route.name === 'companies.view') {
              this.$router.go()
            }
          }
        }))
        .listen('CompanyCreateFailureEvent', (({user, ticker}) => {
          if (user.id === this.user.id) {
            this.error = ticker
            this.company = {tag: {name: ticker}}
            this.type = 'Company'
          }
        }))
        .listen('SecurityCreateSuccessEvent', (({user, company}) => {
          if (user.id === this.user.id) {
            this.company = company
            this.error = null
            this.type = 'Security'
            if (this.$route.name === 'companies.view') {
              this.$router.go()
            }
          }
        }))
        .listen('SecurityCreateFailureEvent', (({user, isin}) => {
          if (user.id === this.user.id) {
            this.error = isin
            this.company = {tag: {name: isin}}
            this.type = 'Security'
          }
        }))
  },

  methods: {
    reset () {
      this.company = null
    },
  },
}
</script>

<style lang="scss">
  .company-created {
    font-size: 14px;
    padding: 1rem;
    position: fixed;
    flex-direction: column;
    display: flex;
    top: 1rem;
    right: 1rem;
    width: 19rem;
    background: #ffffff;
    border-radius: 2px;
    box-shadow: 0 0px 3px rgba(0,0,0,.5);
    border: 1px solid #14803a;
    &--error {
      border-color: #d9331a;
    }
    .btn-link {
      font-size: 14px;
      padding: 0;
      font-weight: normal;
    }
  }
</style>
